import { render, staticRenderFns } from "./AuthorizingPayment.vue?vue&type=template&id=0aa672dc&scoped=true&"
import script from "./AuthorizingPayment.vue?vue&type=script&lang=js&"
export * from "./AuthorizingPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa672dc",
  null
  
)

export default component.exports